import { useEffect, useState } from "react";
import Footer from "@/components/Footer";
import Header from "@/components/Header";
import { Button } from "@/components/ui/button";
import Modal from "@/components/Modal";
import BusinessLeadForm from "@/components/BusinessLeadForm";
import { fetchPageContent } from "@/api/apis";
import HTML_Renderer from "@/components/HTML_Renderer";

const Businesses = () => {
  const [open, setOpen] = useState(false);

  const [content, setContent] = useState(null);

  useEffect(() => {
    fetchPageContent("business").then((res) => {
      const sections = ["head"];
      const sectionsData: any = {};

      Object.keys(res.data.content).map((fieldKey) => {
        const fieldSection = sections.find((sec) => fieldKey.includes(sec));

        if (fieldSection) {
          sectionsData[fieldSection] = {
            ...(sectionsData[fieldSection] || {}),
            [fieldKey.replace(fieldSection + "_", "")]:
              res.data.content[fieldKey],
          };
        }
      });

      setContent(sectionsData);
    });
  }, []);

  return (
    <div className="min-h-screen bg-musicBlack">
      <Header />

      <main className="pt-24">
        {/* ─── HERO ───────────────────────────────────────────────── */}
        <section className="relative py-24 overflow-hidden">
          {/* background */}
          <div className="absolute inset-0 z-0">
            <div className="absolute inset-0 " />
           
          </div>

          {/* foreground */}
          {content?.head && (
            <div className="relative z-10 editorial-container">
              <div className="max-w-3xl">
                <h1 className="text-white font-serif text-4xl md:text-5xl font-bold mb-4">
                  {content.head.title}
                </h1>
                <HTML_Renderer
                  content={content.head.content}
                  className={"mb-12"}
                />

                <Button
                  className="cta-button"
                  size="lg"
                  onClick={() => setOpen(true)}
                >
                  Register Your Business
                </Button>
              </div>
            </div>
          )}
        </section>
      </main>

      <Footer />

      {/* ─── Modal with business lead form ─────────────────────── */}
      <Modal open={open} onClose={() => setOpen(false)}>
        <BusinessLeadForm onClose={() => setOpen(false)} />
      </Modal>
    </div>
  );
};

export default Businesses;
